'use strict'
const ENV = process.env.NODE_ENV

const BASE_URLS = {
    local: 'http://localhost',
    development: 'https://c.api.staging.chloe-eq.fairtility.com',
    production: 'https://w.api.staging.chloe-eq.fairtility.com'
}
const OQ_BASE_URLS = {
    local: 'http://localhost',
    development: 'https://c.api.staging.chloe-egg.fairtility.com',
    production: 'https://w.api.staging.chloe-egg.fairtility.com'
}
const BASE_URL = BASE_URLS[ENV]
const OQ_BASE_URL = OQ_BASE_URLS[ENV]

const SERVICES_PORTS = {
    local: {
        USERS: ':3001',
        INSTRUMENTS: ':3002',
        PATIENTS: ':3002',
        TREATMENTS: ':3002',
        WELLS: ':3002',
        TENANTS: ':3000',
        NOTES: ':3010',
        EQ_LAB_CONNECTOR: ':3011',
        OQ_LAB_CONNECTOR: ':4001',
        VREPRO: ':3100',
        EMR: ':3110'
    }
}
const PORTS = SERVICES_PORTS[ENV] || {}

const getPort = service => PORTS[service] || ''

const URLS = {
    USERS: BASE_URL + getPort('USERS') + '/users',
    UPDATE_USER: BASE_URL + getPort('USERS') + '/users/%s',
    USER_ROLES: BASE_URL + getPort('USERS') + '/roles',
    USER_PROFILE: BASE_URL + getPort('USERS') + '/users/me',
    USER_DATA: BASE_URL + getPort('USERS') + '/users/me/user-data',
    USER_AVATAR: BASE_URL + getPort('USERS') + '/users/me/avatar',
    USER_RECENT_ITEMS: BASE_URL + getPort('USERS') + '/users/me/recent-items',
    USER_FAVORITES: BASE_URL + getPort('USERS') + '/users/me/favorites',
    USER_FAVORITE_ITEM: BASE_URL + getPort('USERS') + '/users/me/favorites/%s',
    USER_SHARE: BASE_URL + getPort('USERS') + '/users/me/share',
    PATIENTS: BASE_URL + getPort('PATIENTS') + '/patients',
    PATIENT: BASE_URL + getPort('PATIENTS') + '/patients/%s',
    SHARE_TO_PATIENT: BASE_URL + getPort('PATIENTS') + '/patients/%s/share-link',
    PATIENT_SHARED_TENANT: BASE_URL + getPort('PATIENTS') + '/patients-public/%s',
    ADD_NOTE: BASE_URL + getPort('NOTES') + '/notes',
    NOTES: BASE_URL + getPort('NOTES') + '/notes?objectId=%s',
    NOTE: BASE_URL + getPort('NOTES') + '/notes/%s',
    TREATMENT: BASE_URL + getPort('TREATMENTS') + '/treatments/%s',
    SLIDES: BASE_URL + getPort('TREATMENTS') + '/slides',
    PATIENT_SHARED_TREATMENT: BASE_URL + getPort('TREATMENTS') + '/treatments/shared-data',
    WELL: BASE_URL + getPort('WELLS') + '/wells/%s',
    UPDATE_WELLS: BASE_URL + getPort('WELLS') + '/wells',
    TENANTS: BASE_URL + getPort('TENANTS') + '/tenants',
    UPDATE_TENANTS: BASE_URL + getPort('TENANTS') + '/tenants/%s',
    UPDATE_TENANT_ADMIN: BASE_URL + getPort('TENANTS') + '/tenants/%s/admin',
    UPLOAD_CLINIC_LOGO: BASE_URL + getPort('TENANTS') + '/tenants/%s/uploadLogo',
    AGENTS: BASE_URL + getPort('TENANTS') + '/tenants/%s/agents',
    INSTRUMENTS: BASE_URL + getPort('INSTRUMENTS') + '/instruments',
    UPDATE_INSTRUMENT: BASE_URL + getPort('INSTRUMENTS') + '/instruments/%s',
    EQ_LAB_CONNECTOR: BASE_URL + getPort('EQ_LAB_CONNECTOR') + '/connectors',
    OQ_LAB_CONNECTOR:
        OQ_BASE_URL + getPort('OQ_LAB_CONNECTOR') + '/lab-connector-service/connectors',
    // UPDATE_VREPRO: BASE_URL + getPort('VREPRO') + '/vrepro/patients',
    UPDATE_EMR: BASE_URL + getPort('EMR') + '/emr-service/emr/sync',
    TREATMENT_LINK: BASE_URL + getPort('TREATMENTS') + '/treatments/link'
}

export default URLS
